// Renders the official Punteria Bartesaghi logo (transparent PNG, green art).
import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_precision-nails-1/artifacts/mfo6tpbu_definitivo.png";

export const LogoMark = ({ size = 72, className = "", alt = "Punteria Bartesaghi" }) => {
  return (
    <img
      src={LOGO_URL}
      alt={alt}
      width={size}
      height={size}
      loading="eager"
      decoding="async"
      draggable={false}
      className={`object-contain select-none ${className}`}
      style={{ width: size, height: size }}
    />
  );
};
